import useLocalAddress from './LocalAddressHook';

export default useLocalAddress;
